import { useState, useEffect } from "react";
import moment from "moment";

const storageKey = "notification-permission";

const useAllowNoti = () => {
  const [isAllowed, setIsAllowed] = useState<boolean | null>(null); // Use null for initial state

  useEffect(() => {
    const checkPermission = async () => {
      if (Notification.permission === "granted") {
        setIsAllowed(true);
        localStorage.removeItem(storageKey);
      } else {
        if (localStorage) {
          const isAllow = localStorage.getItem(storageKey);
          if (isAllow) {
            const allowAndExp = isAllow.split(",");
            if (allowAndExp[0] === "denied") {
              if (moment(allowAndExp[1]).isBefore(moment())) {
                const permission = await Notification.requestPermission();
                if (permission === "granted") {
                  setIsAllowed(true);
                  localStorage.removeItem(storageKey);
                } else {
                  setIsAllowed(false);
                  localStorage.setItem(
                    storageKey,
                    `denied,${moment().add(7, "day").format()}`
                  );
                }
              } else {
                // Still within the "denied" period
                setIsAllowed(false); // or retain the previous isAllowed state
              }
            } else {
              const permission = await Notification.requestPermission();
              if (permission === "granted") {
                setIsAllowed(true);
                localStorage.removeItem(storageKey);
              } else {
                setIsAllowed(false);
                localStorage.setItem(
                  storageKey,
                  `denied,${moment().add(7, "day").format()}`
                );
              }
            }
          } else {
            // No localStorage entry, request permission
            const permission = await Notification.requestPermission();
            if (permission === "granted") {
              setIsAllowed(true);
              localStorage.removeItem(storageKey);
            } else {
              setIsAllowed(false);
              localStorage.setItem(
                storageKey,
                `denied,${moment().add(7, "day").format()}`
              );
            }
          }
        } else {
          // No localStorage available
          const permission = await Notification.requestPermission();
          if (permission === "granted") {
            setIsAllowed(true);
          } else {
            setIsAllowed(false);
          }
        }
      }
    };

    checkPermission();
  }, []); // Empty dependency array means this effect runs only once, on mount

  return { isAllowed };
};

export default useAllowNoti;
